<template>
  <div>
    <h3 v-if="mw && mw.title" class="mb-4">{{ mw.title }}</h3>
    <template v-if="mw.content">
      <p v-for="(t, i) in mw.content" :key="i" class="mb-2">{{ t }}</p>
    </template>
    <div class="d-flex align-center mb-2">
      <v-radio-group v-model="isNew" hide-details dense mandatory class="mt-0 mr-2" :readonly="(isNew == 1 && !!id) || readonly">
        <v-radio label="Выбрать клиента" :value="0"></v-radio>
        <v-radio label="Создать клиента" :value="1"></v-radio>
      </v-radio-group>
      <a-input-selectapi
        :model="{
          api: '/mechti/clients/select',
          filters: {
            status: 1,
          },
        }"
        v-model="id"
        :config="{ dense: true, hideDetails: true }"
        :readonly="(isNew == 1 && !!id) || readonly"
        @selected="onSelectClient"
        dense
        :disabled="!!isNew || readonly"
        class="flex-grow-1"
      />
    </div>
    <hr v-if="isNew == 1 || id" />
    <a-form-model2
      v-if="isNew == 1 || id"
      v-model="data"
      class="mt-4"
      :model="model"
      :modelForm="modelForm"
      :values="data"
      :errors="errors"
      :config="{ dense: true, hideDetails: 'auto', readonly: readonly || !canEdit }"
      @validate="validate($event)"
    />
    <s-tree-block :value="wizard" v-if="getAccess('contract.wizard.debug')" />
    <portal to="v-wizard-action">
      <v-btn v-if="(isNew && !id) || isChanged" @click="submit">Сохранить клиента</v-btn>
      <v-btn v-if="id" @click="onNext">Далее</v-btn>
    </portal>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, genModel, getAccess } from "@/components/mixings";
import { readonly } from "vue";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, genModel, getAccess],
  props: {
    wizard: {
      type: Object,
      default: () => {},
    },
    mw: {
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      m: this.$store.getters["config/get"].models.clients,
      api: "/mechti/clients",
      isNew: 0,
      id: null,
      model: [],
      loaded: false,
      client: {},
      watchValue: null,
    };
  },
  computed: {
    canEdit() {
      return this.getAccess("client.edit", { users: [this.data.createdby_id] });
    },
    readonly() {
      return !!this.wizard?.object?.id;
    },
    config() {
      return this.mw?.config || {}; //.wizardContract;
    },
  },
  created() {
    this.init();
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        let watchField = this.config?.configField;
        if (!watchField) return;
        if (newVal[watchField] !== oldVal[watchField]) {
          this.getModel(newVal[watchField]);
          return;
        }
        if (newVal[watchField] !== this.watchValue) {
          this.getModel(newVal[watchField]);
          this.watchValue = newVal[watchField];
        }
      },
      deep: true,
    },
    isNew(v) {
      if (v) {
        this.id = null;
        this.watchValue = null;
        this.updateData(this.id);
      }
    },
  },
  methods: {
    waitForEvent(eventName, payload) {
      return new Promise((resolve) => {
        this.$emit(eventName, payload, resolve);
      });
    },
    async init() {
      this.loaded = !true;
      this.client = Object.assign({}, this.wizard?.client || {});
      this.id = this.client?.id || null;
      this.updateData(this.id);
      this.isNew = this.client?.isNew || 0;
    },
    async onSelectClient(v) {
      this.id = v?.value || v;
      await this.updateData(this.id);
    },
    async afterFetchData(r) {
      if ((!this.client?.id && r) || this.wizard?.client?.id != this.data?.id) {
        this.client = Object.assign({}, { id: this.data.id, data: this.getDataForModel(this.model, this.data) });
      }
      if (!r && this.client?.id) this.client = {};
      await this.getModel();
      this.loaded = true;
    },
    calcModel(t) {
      //переназначить функцию, потому что немного отличается от того что в библиотеке genModel
      const config = this.config;
      console.log("run calc", config);
      let model = this.calcModelConfig(config, this.m);
      //let model = this.getModelList(this.m, "form", true);

      this.fillFormFromModel(model);
      this.model = model;

      return model;
    },
    async getModel(t) {
      console.log("get model", t, this.config?.configField, this.data);
      let config;
      if (!t && this.config?.configField) t = this.data?.[this.config.configField];
      console.log("tttt", t);
      let conf = JSON.parse(JSON.stringify(this.config || {}));
      const f = conf.configField;
      if (f) {
        console.log("get model", f, this.data[f], this.data);
        config = conf.config.find((el) => {
          if (Array.isArray(el.value)) return el.value.includes(this.data[f]);
          return el.value == this.data[f];
        });
      }
      config = config || conf.default;
      let model = this.calcModelConfig(config);
      if (true)
        model.forEach((el) => {
          if (el.hiddenCreate && !this.data?.id) {
            el.hidden = true;
          }
        });
      this.fillFormFromModel(model);
      this.model = model;
      return true;
    },
    async onNext() {
      if (this.isNew) {
        const result = await this.waitForEvent("save", this.client);
        this.$emit("next");
      } else {
        const result = await this.waitForEvent("save", this.client);
        this.$emit("next");
      }
    },
    async submit() {
      if (await this.validateAll(this.data)) {
        const resp = await this.$axios.get(this.api, {
          params: {
            filters: {
              name: this.data.name,
              id: { condition: "<>", value: this.data.id },
            },
          },
        });
        let status = resp.data.status == "ok";
        if (!status) {
          this.$root.$emit("show-info", {
            text: "Ошибка....",
          });
          return;
        }
        if (resp.data.data.length) {
          this.errors.name = "Имя занято";
          return;
        }

        await this.post(this.data, this.api);
        return true;
      }
      return false;
    },

    afterSave(data, status) {
      if (this.isNew) this.$root._refreshDirs("client", data.id);
      this.client = Object.assign({}, { id: this.data.id, data: this.getDataForModel(this.model, this.data) });

      this.isChanged = false;
      this.onNext();
    },
  },
};
</script>
